import { Link, Navigate, Outlet } from "react-router-dom";
import UserAcState from "./UserAcState";
import Avatar from "../../componants/navbar/avater";
import { useStateContext } from "../../Contexts/ContextProvider";

export default function Account () {
  
  const {user , token  ,notification } = useStateContext  () ; 
  console.log(user);
    return (
    <div className="container-fluid px-2 px-md-4">
     
      <div className="card card-body mx-3 mx-md-4">
        <div className="row gx-4 mb-2">
        
         
          
          <div className="col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0 mx-auto mt-20">
            <div className="nav-wrapper  end-0">

              <ul className="nav nav-pills nav-fill p-1" role="tablist">
                <li className="nav-item">
                  
                  <Link to ="/Account/View" className="nav-link mb-0 px-0 py-1 active " data-bs-toggle="tab"  >
                    <i className="material-icons text-lg ">home</i>
                    <span className="ms-1">Home</span>
                  </Link>
                </li>
               
                <li className="nav-item">
                  <Link to ="/Account/Settings"  className="nav-link mb-0 px-0 py-1 " data-bs-toggle="tab"   >
                    <i className="material-icons text-lg ">settings</i>
                    <span className="ms-1">Settings</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          
        </div>

        <Outlet /> 
        
            
          </div>
        </div>
     
    )
}